import { Table, Database } from './lib/Database';
import type {
    ComputedFieldConfig,
    DatabaseRecord,
    MutationInfo,
    PaginatedResult,
    RelationOptions,
    TriggerConfig,
    WhereCallback,
} from './@types/Database';

export default Database;
export {
    Table,
    Database,
    type ComputedFieldConfig,
    type DatabaseRecord,
    type MutationInfo,
    type PaginatedResult,
    type RelationOptions,
    type TriggerConfig,
    type WhereCallback
};
